import { render } from "./ProView.vue?vue&type=template&id=59670644"
import script from "./ProView.vue?vue&type=script&lang=js"
export * from "./ProView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__